<template>
    <div>
        <Breadcrumb section-name="Raw Material Profit" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="savePurchase">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center">
                                        <h5 class="mb-0 text-primary">Raw Material Profit</h5>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>

                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Name</label>
                                            <input type="text" v-model="addEditParam.customer_name" name="customer_name" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Raw Material Name</label>
                                            <select class="form-control" name="raw_material_id" v-model="addEditParam.raw_material_id" @change="changeRawMaterial($event)">
                                                <option value="">--Select--</option>
                                                <option v-for="each in rawMaterials" v-text="each.name" :value="each.id"></option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Unit</label>
                                            <input type="text" v-model="addEditParam.unit_name" name="unit_name" disabled class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Quantity</label>
                                            <input type="text" v-model="addEditParam.quantity" name="quantity" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Unit Purchase Price</label>
                                            <input type="text" v-model="addEditParam.unit_purchase_price" name="unit_purchase_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Unit Sales Price</label>
                                            <input type="text" v-model="addEditParam.unit_sales_price" name="unit_purchase_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Purchase Price</label>
                                            <input type="text" v-model="addEditParam.purchase_price" disabled name="purchase_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Sales Price</label>
                                            <input type="text" v-model="addEditParam.sales_price" disabled name="sales_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Profit</label>
                                            <input type="text" v-model="addEditParam.profit" name="profit" disabled class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Remarks</label>
                                            <input type="text" v-model="addEditParam.remarks" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-end">
                            <router-link :to="{name: 'order'}" type="button" class="btn btn-secondary me-2 btn-width">Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">
                                Save
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import Table from "../Common/Table.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    name: "Add",
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                date: '',
                customer_name: '',
                raw_material_id: '',
                quantity: '',
                unit_purchase_price: '',
                unit_sales_price: '',
                purchase_price: '',
                sales_price: '',
                profit: '',
                remarks: '',
            },
            rawMaterials: [],
        }
    },
    watch: {
        'addEditParam.quantity': function() {
            this.addEditParam.purchase_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_purchase_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_purchase_price) : '';
            this.addEditParam.sales_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_sales_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_sales_price) : '';
            this.calculateProfit();
        },
        'addEditParam.unit_purchase_price': function() {
            this.addEditParam.purchase_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_purchase_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_purchase_price) : '';
            this.calculateProfit();
        },
        'addEditParam.unit_sales_price': function() {
            this.addEditParam.sales_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_sales_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_sales_price) : '';
            this.calculateProfit();
        },
    },
    methods: {
        changeRawMaterial: function(event, index) {
            let item = this.rawMaterials.find((v) => v.id === Number(event.target.value));
            this.addEditParam.unit_name = item.unit_name;
            this.addEditParam.unit_price = item.price;
        },
        calculateProfit() {
            this.addEditParam.profit =  this.addEditParam.sales_price - this.addEditParam.purchase_price;
        },
        savePurchase: function() {
            this.loading = true;
            ApiService.ClearErrorHandler();
            ApiService.POST(ApiRoutes.RawMaterialProfit + '/save', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.addEditParam = {
                        date: '',
                        customer_name: '',
                        raw_material_id: '',
                        quantity: '',
                        unit_purchase_price: '',
                        unit_sales_price: '',
                        purchase_price: '',
                        sales_price: '',
                        profit: '',
                        remarks: '',
                    }
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        fetchRawMaterial: function() {
            ApiService.POST(ApiRoutes.RawMaterial + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.rawMaterials = res.data.data;
                }
            });
        }
    },
    mounted() {
        this.fetchRawMaterial();
    }
}
</script>
